"use strict";
/* globals module */
/**
 * @module articleSubscriptionsClient
 * @description  Articles Subscriptions Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsClient` uses `articleSubscriptionsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var __1 = require("../");
var ArticleInstanceSubscriptionsClient = /** @class */ (function () {
    function ArticleInstanceSubscriptionsClient(articleSubscriptionsCommentReportedClient, articleSubscriptionsArticleClient, articleSubscriptionsCommentRequiresModerationClient, articleInstanceSubscriptionsRoute) {
        this.articleSubscriptionsCommentReportedClient = articleSubscriptionsCommentReportedClient;
        this.articleSubscriptionsArticleClient = articleSubscriptionsArticleClient;
        this.articleSubscriptionsCommentRequiresModerationClient = articleSubscriptionsCommentRequiresModerationClient;
        this.articleInstanceSubscriptionsRoute = articleInstanceSubscriptionsRoute;
    }
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "commentReported", {
        get: function () {
            return this.articleSubscriptionsCommentReportedClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "article", {
        get: function () {
            return this.articleSubscriptionsArticleClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "commentRequiresModeration", {
        get: function () {
            return this.articleSubscriptionsCommentRequiresModerationClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleInstanceSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d;
    ArticleInstanceSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentReportedClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.ArticleSubscriptionsArticleClient)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentRequiresModerationClient)),
        tslib_1.__param(3, inversify_1.inject(__1.TYPES.ArticleInstanceSubscriptionsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsCommentReportedClient !== "undefined" && __1.ArticleSubscriptionsCommentReportedClient) === "function" ? _a : Object, typeof (_b = typeof __1.ArticleSubscriptionsArticleClient !== "undefined" && __1.ArticleSubscriptionsArticleClient) === "function" ? _b : Object, typeof (_c = typeof __1.ArticleSubscriptionsCommentRequiresModerationClient !== "undefined" && __1.ArticleSubscriptionsCommentRequiresModerationClient) === "function" ? _c : Object, typeof (_d = typeof __1.ArticleInstanceSubscriptionsRoute !== "undefined" && __1.ArticleInstanceSubscriptionsRoute) === "function" ? _d : Object])
    ], ArticleInstanceSubscriptionsClient);
    return ArticleInstanceSubscriptionsClient;
}());
exports.ArticleInstanceSubscriptionsClient = ArticleInstanceSubscriptionsClient;
